export default class ParameterValue {
  id = null;
  parameter = null;
  owner = null;
  value = null;
}